import React from 'react'
import {Field, Formik} from "formik"

import * as Yup from "yup"
import {useHistory} from 'react-router-dom'
import {useTranslation} from "react-i18next"
import store from "@formApp/store"
import {countries, ccs_eu} from "@formApp/utils"
import GenericInput from "@formComponents/fields/GenericInput"
import ConditionalRegistrantInput from "@formComponents/fields/ConditionalRegistrantInput"
import LoginWith from "@formComponents/LoginWith"
import FieldTelephone from "@formComponents/fields/FieldTelephone";
import FieldNation from "@formComponents/fields/FieldNation";
import YesNoChoice from "@formComponents/fields/YesNoChoice";
import FormError from "@formComponents/FormError";
import Spinner from "@formComponents/Spinner";
import Step2host from "./Step2host";

export default () => (
  <Step2host form={(initialValues, validationSchema, onSubmit) => {
    const {formValues, domainsList, loginWithWidget} = React.useContext(store);
    const {t} = useTranslation();
    const [typeOfUser, setTypeOfUser] = React.useState(formValues.getValue('entity') || '1');
    let history = useHistory();
    const selectedItem = domainsList.getSelected();
    if (!selectedItem) history.push('step-1');
    const {data, userIsConnected} = loginWithWidget;

    initialValues = {
      ...initialValues,
      nationality: formValues.getValue('nationality') || '',
      tos0: formValues.getValue('tos0') || '',
      tos1: formValues.getValue('tos1') || false,
      tos2: formValues.getValue('tos2') || '',
      tos3: formValues.getValue('tos3') || '',
      tosAccuracy: formValues.getValue('tosAccuracy') || '',
    };
    validationSchema = {
      ...validationSchema,
      org: Yup.string().when('entity', {
        is: entityValue => (entityValue !== '1'),
        then: Yup.string().required(t('no_org')),
      }),
      org_taxid: Yup.string().when('entity', {
        is: entityValue => (entityValue !== '1'),
        then: Yup.string().when('entity', {
          is: entityValue => (entityValue !== '7'),
          then: Yup.string().matches(/^\d{11}$/, t('err_org_taxid'))
        }).required(t('no_org_taxid'))
      }),
      taxid: Yup.string().when(['entity', 'nationality'], {
        is: (entityValue, nationalityValue) => ((entityValue === '1' &&  nationalityValue !== 'IT') || entityValue === '7'),
        then: Yup.string(),
        otherwise: Yup.string().matches(/^[A-Z]{6}(\d\d)([A-EHLMPRST])(\d\d)[A-Z0-9]{4}[A-Z]$/, t('err_taxid')),
      }).uppercase().required(t('no_taxid')),
      nationality: Yup.string().when('entity', {
        is: '1',
        then: Yup.string().when('nation', {
          is: (nationValue) => (ccs_eu.indexOf(nationValue) < 0),
          then: Yup.string().oneOf(ccs_eu, t('La nazione o la nazionalità devono essere un paese dell\'Unione Europea'))
        }).required(t('no_nationality')),
      }),
      nation: Yup.string().when('entity', {
        is: entityValue => (entityValue === '2' || entityValue === '3' || entityValue === '4' || entityValue === '5' || entityValue === '6'),
        then: Yup.string().oneOf(['IT'], t('Questo tipo di registrante richiede un recapito in Italia'))
      }).when('entity', {
        is: '7',
        then: Yup.string().oneOf(ccs_eu.filter((v) => (v != 'IT')), t('Questo tipo di registrante richiede un recapito in un paese dell\'Unione Europea diverso dall\'Italia'))
      }).when(['entity', 'nationality'], {
        is: (entityValue, nationalityValue) => (entityValue === '1' && ccs_eu.indexOf(nationalityValue) < 0),
        then: Yup.string().oneOf(ccs_eu, t('La nazione o la nazionalità devono essere un paese dell\'Unione Europea'))
      }).required(t('no_nation')),
      tos0: Yup.string().oneOf(['yes'], t('err_tos')).required(t('err_tos')),
      tos1: Yup.boolean().oneOf([true], t('err_tos')).required(t('err_tos')),
      tos3: Yup.string().oneOf(['yes'], t('err_tos')).required(t('err_tos')),
      tosAccuracy: Yup.string().oneOf(['yes'], t('err_tos')).required(t('err_tos')),
    };

    return(
      <Formik
        initialValues={initialValues}
        validationSchema={Yup.object(validationSchema)}
        validateOnChange={false}
        validateOnBlur={true}
        onSubmit={onSubmit}
      >
        {formikProps => (
          <form className='domainRegistration' onReset={formikProps.handleReset} onSubmit={formikProps.handleSubmit}>
            <div className='transitionWrapper'>
              <div className='toTransition'>
                <section className='formSection halfColumn'>

                  <div className='formSection--title'>{t('NomeDominio')}</div>
                  <GenericInput name='domainName' label={initialValues.fullDomainName} disabled="disabled" />

                  {selectedItem.transfer &&
                    <>
                      <div className='formSection--title'>{t('AuthCode')}</div>
                      <GenericInput name='authCode' label={t('AuthCode')} />
                    </>
                  }

                  <div className='formSection--title'>{t('Tipo di registrante')}</div>
                  <Field name="entity">
                    {({field, meta: { touched, error }}) => {
                      const handleChange = (e) => {
                        field.onChange(e);
                        setTypeOfUser(e.target.value);
                      };
                      return (
                        <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                          <select {...field} className='formField --select' onChange={handleChange}>
                            <option value="1">{t('Privato')}</option>
                            <option value="2">{t('Società')}</option>
                            <option value="3">{t('Impresa individuale o libero professionista')}</option>
                            <option value="4">{t('Enti no-profit')}</option>
                            <option value="5">{t('Enti pubblici')}</option>
                            <option value="6">{t('Altri soggetti')}</option>
                            <option value="7">{t('Soggetti EU')}</option>
                          </select>
                          {touched && error && <div className="errorMessage">{error}</div>}
                        </div>
                      )
                    }}
                  </Field>
                  <ConditionalRegistrantInput name='org' label={t('Ragione Sociale')} condition={['2','3','4','5','6','7']} defaultValue='' />
                  <ConditionalRegistrantInput name='org_taxid' label={t('Partita IVA')} condition={['2','3','4','5','6','7']} defaultValue='' />
                  <div className='formSection--title'>
                    {t('Inserisci i dati personali')}
                  </div>
                  <div className='formGroup span-2'>
                    <LoginWith/>
                  </div>
                  <GenericInput name='Nome' label={t('Nome')} />
                  <GenericInput name='Cognome' label={t('Cognome')} />
                  <Field name="Birth">
                    {({field, meta: { touched, error }}) => {
                      const startDate = new Date().getFullYear() - 18;
                      const endDate = new Date().getFullYear() - 110;
                      const years = [];
                      for (let year = startDate; year >= endDate; year--) {
                        years.push(<option key={year} value={year}>{year}</option>)
                      }
                      return (
                        <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                          <select {...field} className='formField --select'>
                            <option value="" disabled >{t('Anno di nascita')}</option>
                            {years}
                          </select>
                          {touched && error && <div className="errorMessage">{error}</div>}
                        </div>
                      )
                    }}
                  </Field>
                  <ConditionalRegistrantInput name='nationality' label={t('Nazionalità')} condition='1' defaultValue=''>
                    {(field, toggleFocus) => (
                      <select {...field} onFocus={toggleFocus} onBlur={toggleFocus} className='formField --select'>
                        <option value="" disabled >{t('Nazionalità')}</option>
                        {countries.map(country => (
                          <option value={country.code} key={country.code}>{country.name}</option>
                        ))}
                      </select>
                    )}
                  </ConditionalRegistrantInput>
                  <GenericInput name='taxid' label={t('Codice fiscale')} />
                </section>
                <section className='formSection halfColumn'>
                  <div className='formSection--title'>{(typeOfUser === '1') ? t('Residenza e recapiti') : t('Sede legale e recapiti')}</div>
                  <FieldNation eu={typeOfUser !== '1'}/>
                  <GenericInput name='address' label={t('Indirizzo')} />
                  <GenericInput name='zip' label={t('CAP')} />
                  <GenericInput name='city' label={t('Città')} />
                  <GenericInput name='prov' label={t('Provincia/Stato')} />
                  <FieldTelephone />
                  <GenericInput name='Email' label={t('Email')} />
                  <GenericInput name='mailConfirm' label={t('Conferma Email')} />
                </section>
                <section className='formSection halfColumn' />
                <section className='formSection'>
                  <YesNoChoice name="tos0" title='Dichiarazioni e assunzioni di responsabilità'>
                    <textarea rows="5" className="large" readOnly id="tos0_a" value={(typeOfUser === '1') ? t('domain_it_tos0_entity_1') : t('domain_it_tos0_entity_other')} />
                  </YesNoChoice>
                  <Field name="tos1">
                    {({field, form, meta: { touched, error }}) => {
                      const textValue = (typeOfUser === '1') ? t('domain_it_tos1_entity_1') : t('domain_it_tos1_entity_other');
                      return (
                        <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                          <div className='formField'>
                            <div className='fieldTitle'>{t('Informativa e acquisizione del consenso ai fini del trattamento del dato per la registrazione del nome a dominio e per la visibilità in Internet')}</div>
                            <textarea rows="5" className="large" readOnly value={textValue} />
                            <div className='choice'>
                              <label>
                                <input type="checkbox" name={field.name} value={true} defaultChecked={field.value} onChange={field.onChange} />
                                {t('Presa visione')}
                              </label>
                            </div>
                          </div>
                          {touched && error && <div className="errorMessage">{error}</div>}
                        </div>
                      )}}
                  </Field>
                  <ConditionalRegistrantInput name='tos2' condition={['1','3']} defaultValue=''>
                    {(field, toggleFocus) => (
                      <div className='formField'>
                        <div className='fieldTitle'>{t('Consenso al trattamento dei dati personali per la diffusione ed accessibilità tramite whois registrazione del nome a dominio e per la visibilità in Internet')}</div>
                        <textarea rows="3" className="large" readOnly value={t('domain_it_tos2_entity_1')} />
                        <div className='choice'>
                          <label>
                            <input type='radio' value='yes' name={field.name} onChange={field.onChange} checked={field.value === 'yes'} />
                            {t('Accetto')}
                          </label>
                        </div>
                        <div className='choice'>
                          <label>
                            <input type='radio' value='no' name={field.name} onChange={field.onChange} checked={field.value === 'no'} />
                            {t('Non Accetto')}
                          </label>
                        </div>
                      </div>
                    )}
                  </ConditionalRegistrantInput>
                  <YesNoChoice name="tosAccuracy" title='Accuratezza dei dati'>
                      <textarea rows="5" className="large" readOnly id="tosAccuracy_a" value={t('domain_it_tos_accuracy')} />
                  </YesNoChoice>
                  <YesNoChoice name="tos3" title='Accettazione esplicita dei seguenti punti'>
                    <textarea rows="5" className="large" readOnly id="tos3" value={(typeOfUser === '1') ? t('domain_it_tos3_entity_1') : t('domain_it_tos3_entity_other')} />
                  </YesNoChoice>
                  <Field name="termsAcceptance">
                    {({field, form, meta: { touched, error }}) => (
                      <div className={`formGroup${(touched && error) ? ' error' : ''}`}>
                        <div className='formField --checkbox'>
                          <div className='fieldTitle'>{t('Termini e condizioni')}</div>
                          <input type="checkbox" name={field.name} value={true} defaultChecked={field.value} onChange={field.onChange} />
                          <label dangerouslySetInnerHTML={{__html: t('altervista_tos_and_privacy')}}></label>
                        </div>
                        {touched && error && <div className="errorMessage">{error}</div>}
                      </div>
                    )}
                  </Field>
                </section>
                <FormError />
                <section className='form-bottom-actions'>
                  <button className='btn-form-default' type="submit">
                    {formikProps.isSubmitting
                      ? <Spinner />
                      : t('Scegli pagamento')
                    }
                  </button>
                </section>
              </div>
            </div>
          </form>
        )}
      </Formik>
    )
  }} />
)